var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangeToneicon = function SvgChangeToneicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.15.7h-.7a.35.35 0 0 0-.35.35v11.9c0 .194.157.35.35.35h.7a.35.35 0 0 0 .35-.35V1.05a.35.35 0 0 0-.35-.35ZM7.7 4.55v4.9a.35.35 0 0 1-.35.35h-.7a.35.35 0 0 1-.35-.35v-4.9a.35.35 0 0 1 .35-.35h.7a.35.35 0 0 1 .35.35Zm4.55 1.05h.7a.35.35 0 0 1 .35.35v2.1a.35.35 0 0 1-.35.35h-.7a.35.35 0 0 1-.35-.35v-2.1a.35.35 0 0 1 .35-.35Zm-10.5.7h-.7a.35.35 0 0 0-.35.35v.7c0 .194.157.35.35.35h.7a.35.35 0 0 0 .35-.35v-.7a.35.35 0 0 0-.35-.35Zm2.1-3.5h.7a.35.35 0 0 1 .35.35v7.7a.35.35 0 0 1-.35.35h-.7a.35.35 0 0 1-.35-.35v-7.7a.35.35 0 0 1 .35-.35Z",
    clipRule: "evenodd"
  })));
};
export default SvgChangeToneicon;